import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Marcus Thompson',
    company: 'Thompson HVAC Services',
    amount: '$180,000',
    text: 'Traditional banks wanted 6 weeks. We received capital in 3 days, allowing us to secure a major contract.'
  }, {
    name: 'Jennifer Martinez',
    company: "Bella's Restaurant Group",
    amount: '$95,000',
    text: 'Efficient, professional, and transparent. The capital allowed us to expand to our third location ahead of schedule.'
  }, {
    name: 'David Chen',
    company: 'Chen Manufacturing LLC',
    amount: '$250,000',
    text: 'The most straightforward funding process we have experienced. Ideal for businesses that need to move fast.'
  }];
  return <section className="relative py-24 px-4 sm:px-6 lg:px-8 overflow-hidden border-t border-zinc-900 bg-black" data-id="element-534">
      <div className="max-w-7xl mx-auto" data-id="element-535">
        <div className="text-center mb-16" data-id="element-536">
          <h2 className="text-3xl md:text-5xl font-medium text-white mb-6" data-id="element-537">
            Trusted by Industry Leaders
          </h2>
          <p className="text-xl text-zinc-400 max-w-2xl mx-auto font-light" data-id="element-538">
            We partner with ambitious founders to fuel their next phase of
            growth.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-539">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-zinc-900/50 border border-zinc-800 p-8 rounded-2xl hover:bg-zinc-900 transition-colors backdrop-blur-sm" data-id="element-540">
              <QuoteIcon className="w-8 h-8 text-zinc-600 mb-6" data-id="element-541" />

              <p className="text-zinc-300 mb-8 leading-relaxed text-lg font-light" data-id="element-542">
                "{testimonial.text}"
              </p>

              <div className="border-t border-zinc-800 pt-6" data-id="element-543">
                <div className="font-medium text-white text-lg mb-1" data-id="element-544">
                  {testimonial.name}
                </div>
                <div className="text-sm text-zinc-500 mb-4" data-id="element-545">
                  {testimonial.company}
                </div>
                <div className="inline-block bg-white/5 border border-white/10 px-3 py-1 rounded-full" data-id="element-546">
                  <span className="text-xs text-zinc-400 uppercase tracking-wider" data-id="element-547">
                    Funded:{' '}
                    <span className="text-white font-semibold" data-id="element-548">
                      {testimonial.amount}
                    </span>
                  </span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}